module.exports = __webpack_public_path__ + "img/Redeéo_120X35.32b6c07c.png";